import { render, staticRenderFns } from "./linea.vue?vue&type=template&id=68bb2954&scoped=true&"
import script from "./linea.vue?vue&type=script&lang=js&"
export * from "./linea.vue?vue&type=script&lang=js&"
import style0 from "./linea.vue?vue&type=style&index=0&id=68bb2954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb2954",
  null
  
)

export default component.exports